export default class extends HTMLElement {
  DEFAULT_HTML = `<div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; color: #1a1a1a; line-height: 1.6;">
  <p>Hi {submitter.first_name},</p>
  <p>You have been invited to review and sign <strong>{template.name}</strong>.</p>
  <p style="text-align: center; margin: 24px 0;">
    <a href="{submitter.link}" style="display: inline-block; background-color: #4F46E5; color: #ffffff; text-decoration: none; padding: 14px 32px; border-radius: 6px; font-size: 16px; font-weight: 600;">Review and Sign</a>
  </p>
  <p>Please contact us by replying to this email if you have any questions.</p>
  <p>Thanks,<br>{account.name}</p>
</div>`

  connectedCallback () {
    this.fieldName = this.dataset.fieldName

    this.toggle = this.querySelector('.js-html-toggle')
    this.htmlPanel = this.querySelector('.js-html-panel')
    this.mdPanel = this.querySelector('.js-md-panel')
    this.htmlTa = this.querySelector('.js-html-textarea')

    this.toggle.addEventListener('change', () => this.handleToggle())

    this.querySelectorAll('.js-insert-var').forEach((btn) => {
      btn.addEventListener('mousedown', (e) => e.preventDefault())
      btn.addEventListener('click', () => this.insertVariable(btn.dataset.var))
    })
  }

  get markdownEditor () {
    const el = this.mdPanel.querySelector('markdown-editor')
    return el && el.editor ? el : null
  }

  get mdHidden () {
    return this.mdPanel ? this.mdPanel.querySelector('input[type=hidden]') : null
  }

  handleToggle () {
    if (this.toggle.checked) {
      // Switching to HTML mode — pull content from markdown editor
      const mdEl = this.markdownEditor
      if (mdEl && mdEl.editor) {
        // Get HTML from Tiptap editor
        const html = mdEl.editor.getHTML()
        if (html && html.trim() !== '<p></p>') {
          this.htmlTa.value = html
        }
      }

      if (!this.htmlTa.value || !this.htmlTa.value.trim().startsWith('<')) {
        this.htmlTa.value = this.DEFAULT_HTML
      }

      this.htmlPanel.classList.remove('hidden')
      this.mdPanel.classList.add('hidden')
      if (this.htmlTa) {
        this.htmlTa.name = this.fieldName
        this.htmlTa.required = true
      }
      if (this.mdHidden) {
        this.mdHidden.name = ''
        this.mdHidden.required = false
      }
    } else {
      // Switching to Markdown mode — push HTML content into Tiptap editor
      const mdEl = this.markdownEditor
      if (mdEl && mdEl.editor && this.htmlTa.value.trim()) {
        mdEl.editor.commands.setContent(this.htmlTa.value)
      }

      this.htmlPanel.classList.add('hidden')
      this.mdPanel.classList.remove('hidden')
      if (this.mdHidden) {
        this.mdHidden.name = this.fieldName
        this.mdHidden.required = true
      }
      if (this.htmlTa) {
        this.htmlTa.name = ''
        this.htmlTa.required = false
      }
    }
  }

  insertVariable (tag) {
    if (!this.htmlTa) return
    const start = this.htmlTa.selectionStart
    const end = this.htmlTa.selectionEnd
    const val = this.htmlTa.value
    this.htmlTa.value = val.substring(0, start) + tag + val.substring(end)
    this.htmlTa.selectionStart = this.htmlTa.selectionEnd = start + tag.length
    this.htmlTa.focus()
  }
}
